import React,{useState,useEffect} from 'react'
import {useNavigate} from 'react-router-dom'

function Logout () {
document.title = 'Çıxış...'
const navigate = useNavigate();

useEffect(()=>{
  handleLogout();
},[])
const handleLogout = async e => {
  localStorage.removeItem('cm_token')
  navigate('/login',{replace:true})
}

  return (
    <></>
  )
}

export default Logout